module.exports = __webpack_public_path__ + "img/illya.b7af418f.jpg";